import { generateClasses } from '../../utilities/components/styles';
import { mediaBreakpointDown, sizes } from 'conversional-theme';
export var Styles = function () {
    var _a;
    return ({
        container: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            width: '100%'
        },
        overlapContainer: (_a = {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                width: '100%',
                backgroundColor: '#fff',
                marginTop: '40px',
                padding: '8px',
                paddingBottom: '20px'
            },
            _a[mediaBreakpointDown(sizes.sm)] = {
                backgroundColor: 'transparent',
                marginTop: '10px'
            },
            _a)
    });
};
export var renderClasses = generateClasses(Styles);
